import React, { memo } from 'react';
import classnames from 'classnames';
import usePageLog from '@gp/hooks/usePageLog';
import Overview from './components/Overview';
import Cost from './components/Cost';
import BudgetTrend from './components/BudgetTrend';
// import Loading from '@gp/components/Loading';
import { useRequest } from 'ahooks';
import { queryProjectList } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverallDetail';
import '@gp/pages/StudioDashboard/StudioOverall/Tabs/Projects/Details/components/Development/index.scss';

interface IDevelopmentProps extends IBaseProps {
  studioId: string;
  studioName: string;
}

const Development: React.FC<IDevelopmentProps> = (props) => {
  const { studioId = '', studioName = '', style, className, ...remains } = props;

  usePageLog({
    pageId: 'STUDIO_OVERALL_DETAILS_PROJECTS_DEVELOPMENT',
    uidType: 'studio_id',
    uid: studioId || '',
    extInfo: studioName,
  });

  // 筛选器列表信息
  const {
    loading,
    data,
  } = useRequest(queryProjectList, {defaultParams: [{studio_id: studioId}]});

  /* if (loading) {
    return (
      <Loading
        style={{position: 'unset'}}
        innerStyle={{height: 'calc(100% - 74px)', top: 74}}
        loading
        loadingBg="#f2f3f5"
      />
    );
  } */

  return (
    <div
      {...remains}
      style={style}
      className={classnames(
        'dbg-studio-overall-details-projects-development',
        className,
      )}
    >
      <Overview filterLoading={loading} filterList={data || []} />
      <Cost filterLoading={loading} filterList={data || []} />
      {/* <BudgetTrend filterList={data || []} /> */}
    </div>
  );
};

export default memo(Development);
